module.exports = __webpack_public_path__ + "static/media/StationM1.618bccb1.jpg";